import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "design-system/molecules/Select"
import { useTranslation } from "react-i18next"
import { ConversationTestingExperimentSchema } from "schema"
import { z } from "zod"

export type TestingExperiment = z.infer<typeof ConversationTestingExperimentSchema>

type Props = {
  options: TestingExperiment[]
  value: TestingExperiment | null
  onChange: (value: TestingExperiment | null) => void
  disabled?: boolean
}

export function TestingExperimentSelect({ options, value, onChange, disabled }: Props) {
  const { t } = useTranslation()

  if (!options.length) return null

  return (
    <div className="flex flex-col gap-4">
      <span className="text-lg">{t("conversations.chat.experiment.title")}</span>
      <Select
        value={value ? JSON.stringify(value) : "production"}
        onValueChange={(key) =>
          onChange(options.find((option) => JSON.stringify(option) === key) ?? null)
        }
        disabled={disabled}
      >
        <SelectTrigger aria-label={t("conversations.chat.experiment.title")}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="production">{t("conversations.chat.experiment.none")}</SelectItem>
          {options.map((option) => (
            <SelectItem key={JSON.stringify(option)} value={JSON.stringify(option)}>
              {t("conversations.chat.experiment.option", option)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
